import { DOMParser } from 'xmldom';

const getRecipeImageCaptionParsed = contentRaw => {
  if (!contentRaw || !contentRaw.length) {
    return null;
  }

  const parser = new DOMParser();
  const figureContent = contentRaw.find(content => content.indexOf('<figure') === 0);

  if (!figureContent) {
    return null;
  }

  try {
    const figureEl = parser.parseFromString(figureContent, 'text/xml').documentElement;

    if (
      figureEl.getAttribute('graphictype') !== 'illustration' &&
      figureEl.getAttribute('float') !== 'inline'
    ) {
      const figcaptionEl = figureEl.getElementsByTagName('a')[0];
      if (!figcaptionEl) {
        return null;
      }

      const captionString = figureEl.getElementsByTagName('a')[0].parentNode.toString();

      // fixing the URL
      return captionString.replace(/href="/g, 'class="link link--energized" href="/recipe/');
    }

    return null;
  } catch (err) {
    console.error('getRecipeImageCaptionParsed error = ', err);
    return null;
  }
};

export default getRecipeImageCaptionParsed;
